import { render, staticRenderFns } from "./ContactAddNew.vue?vue&type=template&id=4d59a565&"
import script from "./ContactAddNew.vue?vue&type=script&lang=js&"
export * from "./ContactAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ContactAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports